'use client';

import { VideoDisplay } from '@/shared';
import { Star } from '@/components/private/star';
import { formatDate } from '@/components/private/actions/format-date';
import ImgClient from '@/components/private/image-client';
import Link from 'next/link';
import { useNavigation } from '@/app/navigation-context';

export function VideoInfoElement({ video, sizes, }: { video: VideoDisplay, sizes?: string }) {
  const href = video?.slug ? `/video/${video.slug}` : ``;
  const { loadingHref, startLoading, } = useNavigation();
  const isLoading = loadingHref === href;

  if (!video?.slug) {
    console.log(`Missing video slug`);
    return <></>;
  }

  if (!video?.poster) {
    console.log(`Missing video poster`);
    return <></>;
  }
  const rating = video.rating;

  return <Link href={href} onClick={() => startLoading(href)} style={{ position: `relative`, }}>
    {isLoading && (
      <div className="nav-loading-overlay">
        <div className="animate-spin h-8 w-8 border-4 border-white border-t-transparent rounded-full" />
      </div>
    )}
    <ImgClient
      image={video.poster}
      signedUrls={video.poster.signedUrls}
      placeholder={video.poster.placeholder ?? ``}
      sizes={sizes} />
    <div className="info">
      <p className="title">{video.title}</p>
      <p className="models">{video.models.map(m => m.name).join(`, `)}</p>
      {rating !== null && <p title={`rating: ${rating}`} className="rating">
        <Star className={rating > 0 ? `active` : ``} />
        <Star className={rating > 1 ? `active` : ``} />
        <Star className={rating > 2 ? `active` : ``} />
        <Star className={rating > 3 ? `active` : ``} />
        <Star className={rating > 4 ? `active` : ``} />
      </p>}
      <p className="release">{formatDate(video.release)}</p>
      {video.length !== null && <p className="length">{getTime(video.length)}</p>}
    </div>
  </Link>;
}

function getTime(time: number) {
  const hoursNumber = Math.floor(time / 3600);
  const minutesNumber = Math.floor((time - (hoursNumber * 3600)) / 60);
  const secondsNumber = time - (hoursNumber * 3600) - (minutesNumber * 60);

  const minutes = minutesNumber < 10 ? `0${minutesNumber}` : `${minutesNumber}`;
  const seconds = secondsNumber < 10 ? `0${secondsNumber}` : `${secondsNumber}`;

  return `${hoursNumber ? `${hoursNumber}:` : ``}${minutes}:${seconds}`;
}
